const imperial = {
  distance: 'feet',
  distance_cgs: 'inch',
  temperature: '°F',
  temperatureWithDegreeSuffix: 'F°',
};
export default imperial;
